<template>
  <v-container>
    <v-card>
      <div class="d-flex align-center" v-if="data">
        <v-avatar color="black" class="ma-3" id="user-icon">
          <span class="white--text headline">{{ initials }}</span>
        </v-avatar>
        <h2 id="user-name">{{ data.user_name }}</h2>
      </div>
      <v-form class="pa-3" v-model="isFormValid">
        <v-text-field
          v-model="userData.user_name"
          label="User Name"
          filled
          @input="changed = true"
          id="profile-user-name"
        ></v-text-field>
        <v-text-field
          v-model="userData.email"
          label="Email"
          filled
          @input="changed = true"
          id="profile-user-email"
          :rules="emailRules"
          required
        ></v-text-field>
        <v-text-field
          v-model="userData.contact.phone"
          label="Phone"
          id="profile-user-phone"
          :rules="phoneRules"
          filled
          @input="changed = true"
        ></v-text-field>
        <v-text-field
          v-model="userData.address.address_1"
          label="Address 1"
          filled
          @input="changed = true"
          id="profile-user-address-1"
        ></v-text-field>
        <v-text-field
          v-model="userData.address.address_2"
          label="Address 2"
          filled
          @input="changed = true"
          id="profile-user-address-2"
        ></v-text-field>
        <v-text-field
          v-model="userData.address.city"
          label="City"
          filled
          @input="changed = true"
          id="profile-user-city"
        ></v-text-field>
        <v-select
          v-model="userData.address.state"
          label="State"
          filled
          @input="changed = true"
          id="profile-user-state"
          :items="getStates"
        ></v-select>
        <v-text-field
          v-model="userData.address.country"
          label="Country"
          filled
          id="profile-user-country"
          @input="changed = true"
        ></v-text-field>
        <v-text-field
          v-model="userData.address.zip"
          label="Zip Code"
          filled
          @input="changed = true"
          id="profile-user-zip"
        ></v-text-field>
        <v-select
          v-if="_getClientGroupsAreSet && isAdmin"
          v-model="userData.group_id[0]"
          label="Groups Viewing"
          filled
          item-value="uuid"
          item-text="group_name"
          @input="changed = true"
          id="profile-user-state"
          :items="all_groups"
        ></v-select>
        <v-select
          v-if="client.client_name === 'avis' && _getClientGroupsAreSet"
          v-model="userData.location"
          label="Location"
          filled
          item-value="group_name"
          item-text="group_name"
          @input="changed = true"
          id="profile-user-state"
          :items="client.groups"
        ></v-select>
        <v-text-field
          v-if="!data"
          v-model="password"
          label="New Password"
          filled
          @input="changed = true"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          required
        ></v-text-field>
      </v-form>
      <v-row class="d-flex justify-center">
        <h4 style="color: red;">{{ getError }}</h4>
      </v-row>
      <v-row class="d-flex justify-center">
        <h4 style="color: red;">{{ getUserError }}</h4>
      </v-row>
      <div class="d-flex justify-center pb-5">
        <v-btn
          large
          :disabled="!isFormValid || !changed"
          color="primary"
          id="update-user-button"
          :style="textStyle"
          @click="clickHandler"
          >{{ buttonText }}</v-btn
        >
      </div>
      <div class="d-flex justify-center pb-5">
        <v-btn
          large
          :disabled="!changed"
          style="width: 90%;"
          @click="resetData"
          id="cancel-user-update"
          >Cancel</v-btn
        >
      </div>
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        id="edits-cancelled-snack"
      >
        {{ snackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { UserPermissions } from '@/mixins';
import router from '../../router';

export default {
  name: 'UserForm',
  props: ['data'],
  mixins: [UserPermissions],
  data: () => ({
    isFormValid: false,
    emailRules: [v => /.+@.+/.test(v) || 'Invalid Email address'],
    phoneRules: [
      v => /^\d+$/.test(v) || 'Phone number must have digits only.',
      v => v.toString().length <= 10 || 'Phone number may not exceed 10 digits',
      v => v.toString().length > 9 || 'Phone number is not long enough.',
    ],
    canUpdate: false,
    snackbar: false,
    snackbarText: false,
    timeout: 2000,
    showPassword: false,
    password: '',
    roles: ['ADMINISTRATOR', 'EDITOR', 'USER'],
    selectedRole: '',
    code: '',
    group_viewing: '',
    groups_viewing: [],
    all_groups: [],
    userData: {
      user_name: '',
      address: {
        address_1: '',
        address_2: '',
        city: '',
        country: '',
        state: '',
        zip: '',
      },
      client_id: '',
      groups: '',
      contact: {
        contact_name: '',
        phone: '',
        email: '',
      },
      hidden_cards: '',
      email: '',
    },
    changed: false,
  }),
  methods: {
    ...mapActions({
      updateUser: 'account/updateUser',
      _createUser: 'account/createUser',
      _initialSignUp: 'auth/initialSignUp',
      _completeSignUp: 'auth/completeSignUp',
    }),
    ...mapMutations({
      setError: 'auth/setError',
      setUserError: 'account/setUserError',
    }),
    clickHandler() {
      if (!this.userData.location) {
        delete this.userData.location;
      }
      this.userData.contact.email = this.userData.email;
      this.userData.contact.contact_name = this.userData.user_name;
      this.changed = false;
      if (this._isLoggedIn) {
        delete this.userData.hidden_cards;
        delete this.userData.groups;
        delete this.userData.client_id;
        delete this.userData.password;
        delete this.userData.error;
        delete this.userData.success;
        delete this.userData.type_name;
        this.updateUser({
          data: this.userData,
          typeName: this.data.type_name,
          setCurrentUser: true,
        });
        this.snackbarText = 'Profile Updated';
        this.snackbar = true;
      } else {
        delete this.userData.hidden_cards;
        delete this.userData.groups;
        delete this.userData.client_id;
        this._createUser({
          data: this.userData,
          password: this.password,
          code: this.code,
        });
      }
    },
    resetData() {
      this.snackbarText = 'Edits Canceled';
      this.snackbar = true;
      this.changed = false;
      this.userData = JSON.parse(JSON.stringify(this.data));
      this.selectedRole = this.userData.role;
    },
    setUserData() {
      this.userData = JSON.parse(JSON.stringify(this.data));
      if (this._getClientGroupsAreSet) {
        this.all_groups = JSON.parse(JSON.stringify(this.client.groups));
        this.all_groups.unshift({ group_name: 'all', uuid: 'all' });
      }
      if (!this.userData.group_id) {
        this.userData.group_id = [];
      }
      if (!this.data.contact || !this.data.address) {
        if (!this.data.contact) {
          this.userData.contact = {
            contact_name: '',
            phone: '',
            email: '',
          };
        }
        if (!this.data.address) {
          this.userData.address = {
            address_1: '',
            address_2: '',
            city: '',
            country: '',
            state: '',
            zip: '',
          };
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      getStates: 'account/getStates',
      _isLoggedIn: 'auth/getIsLoggedIn',
      getError: 'auth/getError',
      getUserError: 'account/getUserError',
      client: 'account/getCurrentClient',
      _getClientGroupsAreSet: 'account/getClientGroupsAreSet',
    }),
    fullAddress() {
      return `${this.userData.address} ${this.userData.address2}`;
    },
    buttonText() {
      if (this._isLoggedIn) {
        return 'Update Profile';
      }
      return 'Register';
    },
    initials() {
      if (this.data.user_name) {
        const first = this.data.user_name[0];
        const initials = `${first}`;
        return initials.toUpperCase();
      }
      return '';
    },
    textStyle() {
      if (this.$vuetify.theme.currentTheme.primary !== '#FFFFFF') {
        return 'color: white !important; width:90%;';
      }
      return 'color: black !important; width:90%;';
    },
  },
  mounted() {
    if (this.data) {
      this.setUserData();
    }
    this.code = router.currentRoute.query.code;
    this.setError(null);
  },
  watch: {
    data: {
      handler() {
        this.setUserData();
      },
      deep: true,
    },
    userData: {
      handler() {},
      deep: true,
    },
    _getClientGroupsAreSet() {
      if (this._getClientGroupsAreSet) {
        this.all_groups = JSON.parse(JSON.stringify(this.client.groups));
        this.all_groups.unshift({ group_name: 'all', uuid: 'all' });
      }
    },
  },
};
</script>

<style></style>
